import { PropTypes } from 'react';
import { withRouter } from 'react-router';
import moment from 'moment';

import { routerPropType } from '../../../../proptypes';
import { trackTicketClick } from '../../../../utils/tracking';

import TicketListItem from './component';

/**
 * Determine the call-to-action button/link label based on ticket.
 */
const getButtonLabelForTicket = (ticket) => {
  switch (ticket.availability.type) {
    case 2: // Sold out
      return 'Sold out';
    case 3: // Coming Soon
    case 4: // Entry Closed
      return 'Closed';
    case 0: // Not Available
    case 1: // Book Now
    default:
      return ticket.charityTickets ? 'More' : 'Book';
  }
};

/**
 * Create the button/link props based on ticket availability.
 */
const getButtonPropsForTicket = (ticket, hash) => {
  switch (ticket.availability.type) {
    case 0: // Not Available
      return { disabled: true };
    case 2: // Sold out
    case 3: // Coming Soon
    case 4: // Entry Closed
      return { primary: true, disabled: true };
    case 1: // Book Now
    default:
      return {
        primary: true,
        ...(ticket.bookingEnabled
          ? { to: { pathname: `/book/${ticket.id}`, hash } }
          : {
            href: ticket.bookingUrl,
            onClick: () => trackTicketClick(ticket),
            rel: 'noopener noreferrer nofollow',
          }),
      };
  }
};

/**
 * Container to determine presentational state for component.
 */
const TicketListItemContainer = ({ router, ticket }) =>
  TicketListItem({
    // Info
    title: ticket.title,
    buttonLabel: getButtonLabelForTicket(ticket),
    buttonProps: getButtonPropsForTicket(ticket, router && router.location.hash),

    // Availability
    ...(ticket.availability.from &&
      moment.utc(ticket.availability.from) > moment.utc() && {
        availableDate: ticket.availability.from,
        availableDateFormatted: moment.utc(ticket.availability.from).format('DD MMM YY'),
      }),
    ...(ticket.availability.to && {
      expiryDate: ticket.availability.to,
      expiryLabel: moment.utc(ticket.availability.to) < moment.utc() ? 'Expired' : 'Expires',
      expiryDateFormatted: moment.utc(ticket.availability.to).format('DD MMM YY'),
    }),

    // Prices
    discountPriceFormatted: ticket.discountPriceFormatted,
    rrpFormatted: ticket.rrpFormatted,
    hasBookingFee: !!ticket.fee,

    // Charity tickets
    isCharityTicket: ticket.charityTickets,
    ...(ticket.charityDetails && {
      charityName: ticket.charityDetails.name,
      charityDescription: ticket.charityDetails.description,
    }),
  });

TicketListItemContainer.propTypes = {
  router: routerPropType,
  ticket: PropTypes.shape({
    availability: PropTypes.shape({
      from: PropTypes.string,
      to: PropTypes.string,
    }).isRequired,
    charityDetails: PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
    discountPriceFormatted: PropTypes.string,
    fee: PropTypes.number,
    rrpFormatted: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

const TicketListItemContainerWithRouter = withRouter(TicketListItemContainer);

export default TicketListItemContainerWithRouter;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/components/TicketListItem/container.js